<script setup>
  import {
    computed,
    nextTick,
    onMounted,
    ref,
    watch
  } from 'vue'

  import { usePropertySearch } from '@composables/usePropertySearch.js'
  import { usePropertySearchBox } from '@composables/usePropertySearchBox.js'
  import { useI18n } from '@shared/i18n.js'

  const mode = ref(null)
  const openingOtherSearch = ref(false)
  const openingSpSearch = ref(false)
  const refDropdownPrice = ref(null)

  const optionsBedrooms = [{ value: 1, text: '1+' }, { value: 2, text: '2+' }, { value: 3, text: '3+' }, { value: 4, text: '4+' }, { value: 5, text: '5+' }]
  const SELECTOR_SELECT_TAG = ".container.-search .sumo_select select"

  const {
    Modes,
    bedroomsFrom,
    city,
    location,
    optionsPrefectures,
    prefectureCities,
    priceFrom,
    priceTo,
    propertyType,
    roomsLayout,
    type,
    labelPrice,
    locale,
    optionsPrice,
    optionsPropertyTypes,
    optionsRoomsLayout,
    observePrefectureCities,
    propertiesUrl,
    clearViewMode,
    getViewMode,
    switchViewMode,
  } = usePropertySearch({
    afterGetPrefectures: () => initializeSelect()
  })

  const { showingPropertySearchBox } = usePropertySearchBox()
  const { isEn, mt, t } = useI18n()

  const {
    propertySearchByCityPath,
    propertySearchByTrainPath
  } = window.app.common

  const showSwitchMapView = window.app.page && window.app.page.show_switch_map_view ? true : false

  clearViewMode() // サイト外からの遷移の場合にクリアする

  onMounted(() => {
    if (window.app.page && window.app.page.search_key) {
      const searchKey = window.app.page.search_key
      bedroomsFrom.value = searchKey.bedrooms_from
      city.value = searchKey.city
      location.value = searchKey.location
      priceFrom.value = searchKey.price_from ? parseInt(searchKey.price_from) : null
      priceTo.value = searchKey.price_to ? parseInt(searchKey.price_to) : null
      if (searchKey.property_type) {
        propertyType.value = Array.isArray(searchKey.property_type) ? searchKey.property_type : [searchKey.property_type]
      }
      type.value = searchKey.type
      roomsLayout.value = searchKey.rooms_layout
    }

    setTimeout(() => initializeMode(), 50)
    observePrefectureCities()
    nextTick(() => $(SELECTOR_SELECT_TAG).SumoSelect())
  })

  watch(prefectureCities, () => {
    nextTick(() => {
      const element = $(".search-city-ward")
      element[0].sumo.unload()
      element.SumoSelect()
    })
  })

  const optionsPropertyTypesSp = computed(() => {
    if (!optionsPropertyTypes.value || optionsPropertyTypes.value.length == 0) return optionsPropertyTypes.value
    return [optionsPropertyTypes.value[optionsPropertyTypes.value.length - 1], ...optionsPropertyTypes.value.slice(0, optionsPropertyTypes.value.length - 1)]
  })
  const priceFromLabel = computed(() => priceFrom.value ? priceFrom.value.toLocaleString() : '')
  const priceLabel = computed(() => priceFrom.value || priceTo.value ? `${priceFromLabel.value}〜${priceToLabel.value}` : `${labelPrice.value('activerecord.attributes.property.price')} (${t('c.yen')})`)
  const priceToLabel = computed(() => priceTo.value ? priceTo.value.toLocaleString() : '')

  /**
   * Other Searchを閉じる
   */
  const handleClickCloseMore = () => {
    openingOtherSearch.value = false
  }

  /**
   * List Viewをクリック
   */
  const handleClickListView = () => {
    // Viewの切り替えが上手くいかなくて使ってない。できればリロードしたくないが余裕があれば検討
    // document.getElementById("btn-trigger-switch-list-view").click()

    switchViewMode(Modes.LIST)
  }

  /**
   * Map Viewをクリック
   */
  const handleClickMapView = () => {
    /* Viewの切り替えが上手くいかなくて使ってない。
    const element = document.getElementById("btn-trigger-switch-map-view")
    if (!element) {
      setTimeout(() => handleClickMapView(), 100)
      return
    }

    element.click()
    */

    switchViewMode(Modes.MAP)
  }

  /**
   * Other Searchを開く
   */
  const handleClickMore = () => {
    openingOtherSearch.value = !openingOtherSearch.value
    if (window.innerWidth <= 992) {
    }
    else {
      $(".search_filters").slideToggle();
    }
  }

  /**
   * スマホ版の検索メニュークリック
   */
  const handleClickSearchSp = () => {
    openingSpSearch.value = !openingSpSearch.value

    // ココにない要素なのでやむを得ない
    if (openingSpSearch.value) {
      $('#gnav').addClass('hasOpen')
      if (window.innerWidth <= 992) {
        $('body').addClass('is-noScroll');

       const headerH = $("header").height();
       const scrollNum = $(window).scrollTop();
       const menuPosition = $('#primary_search').offset().top;
       const fixedNum = menuPosition - scrollNum + 48;
       $("#primary_search .selects").css('top', fixedNum + 'px');
       $("#primary_search .search_filters").css('bottom', fixedNum + 'px');
      }
    }
    else {
      $('#gnav').removeClass('hasOpen')
      if (window.innerWidth <= 992) {
        $('body').removeClass('is-noScroll');
        $('.l-main').toggleClass('is-noScroll');
      }
    }
  }

  /**
   * 金額の入力
   */
  const handleInputPriceTo = () => {
    if (window.innerWidth >= 992) {
      refDropdownPrice.value.classList.remove('show')
    }
  }

  /**
   * 売買／賃貸の切替
   */
  const handleInputType = () => {
    initializeSelect()
    priceFrom.value = ''
    priceTo.value = ''
    bedroomsFrom.value = ''
    propertyType.value = []
  }

  /**
   * Viewの初期化
   */
  const initializeMode = () => {
    setTimeout(() => mode.value = getViewMode(), 100)
  }

  /**
   * 選択肢の初期化
   */
  const initializeSelect = () => {
    setTimeout(() => {
      $(SELECTOR_SELECT_TAG).each(function() {
        this.sumo.unload()
      })
      $(SELECTOR_SELECT_TAG).SumoSelect();
    }, 100)
  }

  /**
   * 検索処理
   */
  const submit = () => {
    window.location.href = propertiesUrl()
  }
</script>

<template>
  <div v-show="showingPropertySearchBox" id="primary_search">
    <div class="container -search">
      <div class="toggle_contents_header" @click="handleClickSearchSp">{{ t('c.search_for_properties') }}</div>
      <div :class="{ open: openingSpSearch }" class="c-sumoselect selects selects_pc sumo_select toggle_contents toggle_contents_flex">
        <button type="button" class="navbar-close seSelect" data-bs-dismiss="offcanvas" aria-label="Close" @click="handleClickSearchSp"></button>
        <div class="inner">
          <div class="c-sumoselect select_box">
            <label class="select_type_a properties-type">
              <select v-model="type" class="search-properties-type" tabindex="-1" @change="handleInputType">
                <option value="sale">{{ t(isEn ? 'c.for_sale.other' : 'c.for_sale') }}</option>
                <option value="rent">{{ t(isEn ? 'c.for_rent.other' : 'c.for_rent') }}</option>
              </select>
            </label>

            <div class="select_sp">
              <ul class="serch_select form-search-properties">
                <li>
                  <input v-model="type" class="radio-type" name="type" type="radio" value="sale" @input="handleInputType">
                  <label>{{ t('c.buy') }}</label>
                </li>
                <li>
                  <input v-model="type" class="radio-type" name="type" type="radio" value="rent" @input="handleInputType">
                  <label>{{ t('c.rent') }}</label>
                </li>
              </ul>
            </div>

            <label class="select_type_a location">
              <p class="title_sp">{{ t('c.search_by.prefecture') }}</p>
              <!-- <select class="search-location" placeholder="Property Location" tabindex="-1"> -->
              <select v-model="location" class="search-location" tabindex="-1" :placeholder="t('c.search_by.prefecture')" name="location">
                <option disabled selected></option>
                <option v-for="option in optionsPrefectures" :key="`prefecture-${option.value}`" :value="option.en">{{ option.label }}</option>
              </select>
            </label>

            <label class="select_type_a city-ward">
              <select v-model="city" class="search-city-ward" :placeholder="t('c.city_ward')" :disabled="prefectureCities.length === 0" tabindex="-1">
                <option disabled selected></option>
                <option v-for="city in prefectureCities" :key="`city-${city.value}`" :value="city.value">{{ city.label }}</option>
              </select>
            </label>

            <div class="search_nav select_price">
              <a :class="{ 'is-true': priceFrom || priceTo }" class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ priceLabel }}
              </a>
              <div ref="refDropdownPrice" class="dropdown-menu" @click.stop>
                <p class="price_title">{{ t('c.search_box.price_range') }}</p>
                <div class="c-fBox">
                  <div class="item">
                    <p class="item_title">{{ t('c.search_box.minimum') }}</p>
                    <label class="select_type_a select_price_min">
                      <select v-model="priceFrom" class="search-price-from-min" :placeholder="labelPrice('c.no_min_price_short')" name="price_from_min" tabindex="-1">
                        <option disabled></option>
                        <option v-for="(option, index) in optionsPrice" :key="`price-from-${index}`" :value="option">{{ option.toLocaleString() }}</option>
                      </select>
                    </label>
                  </div>
                  <p class="text">ー</p>
                  <div class="item">
                    <p class="item_title">{{ t('c.search_box.maximum') }}</p>
                    <label class="select_type_a select_price_max">
                      <select v-model="priceTo" class="search-price-from-max" :placeholder="labelPrice('c.no_max_price_short')" name="price_from_max" tabindex="-1" @change="handleInputPriceTo">
                        <option disabled></option>
                        <option v-for="(option, index) in optionsPrice" :key="`price-to-${index}`" :value="option">{{ option.toLocaleString() }}</option>
                      </select>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <template v-if="locale == 'ja'">
              <label class="select_type_a location">
                <p class="title_sp">{{ mt('property', 'beds') }}</p>
                <!-- <select class="search-location" placeholder="Property Location" tabindex="-1"> -->
                <select v-model="roomsLayout" class="search-location" tabindex="-1" :placeholder="mt('property', 'beds')">
                  <option disabled selected></option>
                  <option v-for="option in optionsRoomsLayout" :key="`rooms-layout-${option.value}`" :value="option.value">{{ option.text }}</option>
                </select>
              </label>
            </template>
            <template v-else>
              <label class="select_type_a select_property_type select_beds u-pc">
                <!-- <p class="title_sp">Beds</p> -->

                <select v-model="bedroomsFrom" class="search-location" :placeholder="mt('property', 'beds')" tabindex="-1">
                  <option disabled selected></option>
                  <option class="u-pc">Number of Bedrooms</option>
                  <option value="">Any</option>
                  <option v-for="option in optionsBedrooms" :key="`bedroom-${option.value}`" :value="option.value">{{ option.text }}</option>
                </select>
              </label>
            </template>

            <div v-if="locale != 'ja'" class="search_nav select_beds u-sp">
              <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown"
                aria-expanded="false">{{ mt('property', 'beds') }}</a>
              <div class="dropdown-menu">
                <p class="price_title">Number of Bedrooms</p>
                <div class="beds_list">
                  <label><input v-model="bedroomsFrom" type="radio" value="" name="beds"><span>Any</span></label>
                  <template v-for="option in optionsBedrooms" :key="`bedroom-sp-${option.value}`">
                    <label><input v-model="bedroomsFrom" type="radio" :value="option.value"><span>{{ option.text }}</span></label>
                  </template>
                </div>
              </div>
            </div>

            <label class="select_type_a select_property_type">
              <p class="title_sp">{{ t('c.type_of_home') }}</p>
              <select v-model="propertyType" class="search-property-type-detail select_pc" multiple="multiple" :placeholder="t('c.search_by.property_type')" tabindex="-1">
                <option value="" class="u-pc">{{ t('c.search_box.home_type') }}</option>
                <option v-for="option in optionsPropertyTypes" :key="`property-type-${option.value}`" :value="option.value">{{ option.text }}</option>
              </select>
              <div class="checkBox select_sp">
                <template v-for="option in optionsPropertyTypesSp" :key="`property-type-${option.value}`">
                  <input v-model="propertyType" :id="`property-type-${option.value}`" :value="option.value" class="visually-hidden" type="checkbox" />
                  <label :for="`property-type-${option.value}`">{{ option.text }}</label>
                </template>
              </div>
            </label>
            <div class="search search_pc">
              <button class="btn btn_search btn-search-main" type="button" @click="submit">
                <i class="ico-search"></i>{{ t('c.search') }}</button>
            </div>
          </div>

          <div class="search_filters">
            <p class="serch_line">or</p>
            <div class="search search_sp">
              <button class="btn btn_search btn-search-main" type="button" @click="submit">
                <i class="ico-search"></i>{{ t('c.search') }}</button>
            </div>
            <p class="more search_sp">
              <span class="more_open" @click="handleClickMore">{{ t('c.search_by.more_filters') }}</span>
            </p>
            <div :class="{ open: openingOtherSearch }" class="inner other_search">
              <button type="button" class="other_search_close" @click="handleClickCloseMore"></button>
              <a :href="propertySearchByTrainPath" class="btn btn_search btn-open-railway-dialog">
                {{ t('c.search_by.search_by_train_station') }}<i class="fa-solid fa-train-subway"></i>
              </a>
              <a :href="propertySearchByCityPath" class="btn btn_search btn-open-city-dialog">
                {{ t('c.search_by.search_by_city') }}<i class="fa-solid fa-map-location-dot"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <p :class="{ open: openingOtherSearch }" class="more search_pc">
        <span class="more_open" @click="handleClickMore">{{ t('c.search_by.more_filters') }}</span>
      </p>

      <div v-if="showSwitchMapView" class="serch_select_list">
        <div class="select_list" @click="handleClickListView">
          <input v-model="mode" class="list-type -list" type="radio" :value="Modes.LIST">
          <label><i class="fa-solid fa-list"></i></label>
        </div>
        <div class="select_map" @click="handleClickMapView">
          <input v-model="mode" class="list-type -map" type="radio" :value="Modes.MAP">
          <label><i class="fa-solid fa-location-dot"></i></label>
        </div>
      </div>
    </div>
  </div>
</template>
